import { MoneyBox, NumberBoxLayoutStyle } from '@apply/components';
import { useStandardLoanStore } from '../../../../../../../state/standardLoanStore';
import { toPositiveNumber } from './functions/toPositiveNumber';

/**
 * Locked when the loan has more than one property (the fee comes from the properties; see PropertySlice.properties'
 * TODO).
 */
export const OriginationFeeField = () => {
    const value = useStandardLoanStore((state) => state.loan.originationFee);
    const propertyCount = useStandardLoanStore((state) => state.properties.length);
    const updateLoan = useStandardLoanStore((state) => state.updateLoan);

    return (
        <MoneyBox
            id='loanOriginationFee'
            value={value}
            onChange={(amount) => updateLoan({ originationFee: toPositiveNumber(amount) })}
            label='Origination Fee'
            disabled={propertyCount > 1}
            displayChange={true}
            width='100%'
            height='36px'
            layoutStyle={NumberBoxLayoutStyle.Horizontal}
            labelWidth='150px'
        />
    );
};
